export const NotificationAction = Object.freeze({
  NEW_CONTRACT: "NEW_CONTRACT",
  NEW_LOAD_COMPOSITION: "NEW_LOAD_COMPOSITION",
  UPDATED_LOAD_COMPOSITION: "UPDATED_LOAD_COMPOSITION",
  CANCELED_ORDER: "CANCELED_ORDER",
  ACTIVATE_MATERIAL: "ACTIVATE_MATERIAL",
  MASTERDATA_AUTOMATION_UPDATES_AVAILABLE_REVIEW: "MASTERDATA_AUTOMATION_UPDATES_AVAILABLE_REVIEW",
});
